import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import FileListUI from './FileListUI.js'

class FileListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      // download
      fileDownloadSubmitted: false,
      // upload
      fileUploadMode: false,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: null,
      fileUploadSubmitted: false,
      //
      deleteFileMode: false
    }
  }

  render() {
    return (
      <FileListUI
        context={this.props.context}
        account={this.props.account}
        errorList={this.state.errorList}
        accountFileList={this.props.accountFileList}
        folder={this.props.folder}
        title={this.props.title}
        // metadata
        fileSubmitted={this.props.fileSubmitted}
        onFileClick={this.props.onFileClick}
        // download
        fileDownloadSubmitted={this.state.fileDownloadSubmitted}
        onFileDownloadClick={this.onFileDownloadClick}
        // upload
        fileUploadMode={this.state.fileUploadMode}
        fileUploadSubmitted={this.state.fileUploadSubmitted}
        fileUploadSuccessMsg={this.state.fileUploadSuccessMsg}
        fileUploadErrorList={this.state.fileUploadErrorList}
        onFileUploadClick={() => { this.setState({ fileUploadMode: true }) }}
        onfileUploadCancel={() => { this.setState({ fileUploadMode: false }) }}
        onfileUpload={this.onfileUpload}
        //
        selectedFile={this.state.selectedFile}
        deleteFileMode={this.state.deleteFileMode}
        onFileDeleteClick={this.onFileDeleteClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onfileUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({
      fileUploadSubmitted: true,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: []
    })
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/files/folders/${this.props.folder}/validation`,
      this.onfileUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onfileUploadCallback = (response) => {
    this.setState({ fileUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      fileUploadSuccessMsg: response.success,
      fileUploadErrorList: errorList,
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          fileUploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  onFileDownloadClick = (event) => {
    let folder = event.currentTarget.getAttribute('data-folder')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    this.setState({ fileDownloadSubmitted: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/files/${fileName}/folders/${folder}/fileDownloadSignedUrl`,
      this.onFileDownloadClickCallback, null, null
    )
  }

  onFileDownloadClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      fileDownloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onFileDeleteClick = (event) => {
    let folder = event.currentTarget.getAttribute('data-folder')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    this.setState({
      successMsg: null,
      errorList: [],
      deleteFileMode: true,
      selectedFile: fileName
    })
    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/files/${fileName}/folders/${folder}`,
      this.onFileDeleteClickCallback, {}
    )
  }

  onFileDeleteClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }
    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteFileMode: false
    })
    if (errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
    }
  }
}

export default withRouter(FileListSF)
